import { MstSyouninGroupUsersApi } from "@/api/MstSyouninGroupUsersApi";
import { MstSyouninGroupUser, UpsertSyouninGroupUserReq } from "@/types/SyouninGroup";

export class MstSyouninGroupUsersService {

  /**
  * 承認グループの承認者として登録するユーザーを検索します
  * @returns
  */
  public async getSelectableSyouninGroupUserList(syouninType?: number): Promise<MstSyouninGroupUser[]> {
    const api = new MstSyouninGroupUsersApi();
    try {
      return await api.getSelectableSyouninGroupUserList(syouninType);
    } catch (e) {
      return [];
    }
  }

  /**
   * 承認グループを検索します
   * @returns
   */
  public async searchSyouninGroup(): Promise<any> {
    const api = new MstSyouninGroupUsersApi();
    try {
      return await api.searchSyouninGroup();
    } catch (e) {
      return null;
    }
  }

  /**
   * 承認グループに所属するユーザーを新規登録します
   * @param params
   * @returns
   */
  public async createSyouninGroupUsers(params: UpsertSyouninGroupUserReq): Promise<any> {
    const api = new MstSyouninGroupUsersApi();
    try {
      return await api.createSyouninGroupUsers(params);
    } catch (e) {
      return null;
    }
  }

  /**
   * 承認グループに所属するユーザーを追加します
   * @param params
   * @returns
   */
  public async addSyouninGroupUsers(params: UpsertSyouninGroupUserReq): Promise<any> {
    const api = new MstSyouninGroupUsersApi();
    try {
      return await api.addSyouninGroupUsers(params);
    } catch (e) {
      return null;
    }
  }

  /** 承認グループに所属するユーザーを削除します */
  public async deleteSyouninGroupUser(mstSyouninGroupUserId: number, mstSyouninGroupId: number): Promise<any> {
    const api = new MstSyouninGroupUsersApi();
    try {
      return await api.deleteSyouninGroupUser(mstSyouninGroupUserId, mstSyouninGroupId);
    } catch (e) {
      return null;
    }
  }
}
